(function () {
  if (window.__fllZenInit) return; window.__fllZenInit = true;
  if (!document.querySelector('[data-zn]')) return;
  /* ---------- add to cart (same as shop: refresh sections + open cart drawer) ---------- */
  function refreshCartDrawer() {
    var drawer = document.querySelector('cart-drawer');
    var bubble = document.getElementById('cart-icon-bubble');
    var wanted = [];
    if (drawer) wanted.push('cart-drawer');
    if (bubble) wanted.push('cart-icon-bubble');
    if (!wanted.length) return Promise.resolve();
    /* Use site root — collection templates 404 on ?sections=. */
    return fetch((window.Shopify.routes.root || '/') + '?sections=' + wanted.join(','))
      .then(function (r) {
        if (!r.ok) throw new Error('sections ' + r.status);
        return r.json();
      })
      .then(function (sections) {
        if (sections['cart-drawer'] && drawer) {
          var html = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
          var fresh = html.querySelector('cart-drawer');
          if (fresh) {
            drawer.innerHTML = fresh.innerHTML;
            drawer.classList.toggle('is-empty', fresh.classList.contains('is-empty'));
          }
          if (typeof drawer.open === 'function') drawer.open();
        }
        if (sections['cart-icon-bubble'] && bubble) {
          var b = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
          var sectionEl = b.querySelector('.shopify-section') || b.body;
          if (sectionEl) bubble.innerHTML = sectionEl.innerHTML;
        }
      });
  }

  function addToCart(items, then, onError, allowSubRetry) {
    if (allowSubRetry === undefined) allowSubRetry = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (body) { return { ok: r.ok, body: body }; });
    }).then(function (res) {
      if (!res.ok) {
        var msg = (res.body && (res.body.description || res.body.message)) || 'Could not add that to the cart.';
        var hadPlan = items.some(function (it) { return it && it.selling_plan; });
        if (allowSubRetry && hadPlan && (/B2B/i.test(msg) && /one-time/i.test(msg))) {
          var once = items.map(function (it) {
            var copy = {};
            for (var k in it) if (Object.prototype.hasOwnProperty.call(it, k) && k !== 'selling_plan') copy[k] = it[k];
            return copy;
          });
          return addToCart(once, then, onError, false);
        }
        if (onError) onError(msg); else window.alert(msg);
        return;
      }
      ['cart:refresh', 'cart:build', 'cart-updated', 'cart:updated'].forEach(function (name) {
        document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: { cart: res.body } }));
      });
      return refreshCartDrawer().catch(function (err) {
        console.warn('[fll] cart drawer refresh failed', err);
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function') {
          try { drawer.open(); } catch (e) {}
        }
      }).then(function () {
        if (then) then();
      });
    }).catch(function (e) {
      if (onError) onError('Network error: ' + e.message); else window.alert('Network error: ' + e.message);
    });
  }


  var VIDEOS = [
    { src: 'https://freelifelabs.com/cdn/shop/videos/c/vp/10ba6f7853724680a4e142d5c2d02eb9/10ba6f7853724680a4e142d5c2d02eb9.HD-1080p-2.5Mbps-36775999.mp4?v=0', poster: 'https://freelifelabs.com/cdn/shop/files/preview_images/10ba6f7853724680a4e142d5c2d02eb9.thumbnail.0000000000_540x.jpg?v=1729559155', cap: 'NerveReverse customer', c: 'nerve' },
    { src: 'https://freelifelabs.com/cdn/shop/videos/c/vp/951575245254493aa0d3d3175d4658f1/951575245254493aa0d3d3175d4658f1.HD-1080p-7.2Mbps-36396112.mp4?v=0', poster: 'https://freelifelabs.com/cdn/shop/files/preview_images/951575245254493aa0d3d3175d4658f1.thumbnail.0000000000_540x.jpg?v=1729101962', cap: 'Derm 42 customer', c: 'skin' },
    { src: 'https://freelifelabs.com/cdn/shop/videos/c/vp/5effd00ea2944a148a8bf8c97e071170/5effd00ea2944a148a8bf8c97e071170.HD-720p-1.6Mbps-36775998.mp4?v=0', poster: 'https://freelifelabs.com/cdn/shop/files/preview_images/5effd00ea2944a148a8bf8c97e071170.thumbnail.0000000000_540x.jpg?v=1729559131', cap: 'NerveReverse customer', c: 'nerve' },
    { src: 'https://freelifelabs.com/cdn/shop/videos/c/vp/402a965e80e247b79f1233d1231724f0/402a965e80e247b79f1233d1231724f0.HD-720p-1.6Mbps-36929057.mp4?v=0', poster: 'https://freelifelabs.com/cdn/shop/files/preview_images/402a965e80e247b79f1233d1231724f0.thumbnail.0000000000_540x.jpg?v=1729712733', cap: 'Derm 42 customer', c: 'skin' },
    { src: 'https://freelifelabs.com/cdn/shop/videos/c/vp/02011b1916f3425abd6a68941e0fa8ff/02011b1916f3425abd6a68941e0fa8ff.HD-1080p-2.5Mbps-36776003.mp4?v=0', poster: 'https://freelifelabs.com/cdn/shop/files/preview_images/02011b1916f3425abd6a68941e0fa8ff.thumbnail.0000000000_540x.jpg?v=1729559120', cap: 'NerveReverse customer', c: 'nerve' },
    { src: 'https://freelifelabs.com/cdn/shop/videos/c/vp/e07e1136e56244428b2449f899baa027/e07e1136e56244428b2449f899baa027.HD-1080p-2.5Mbps-36776002.mp4?v=0', poster: 'https://freelifelabs.com/cdn/shop/files/preview_images/e07e1136e56244428b2449f899baa027.thumbnail.0000000000_540x.jpg?v=1729559116', cap: 'NerveReverse customer', c: 'nerve' },
    { src: 'https://freelifelabs.com/cdn/shop/videos/c/vp/d38c6004b9254ec2a89176e0fbec6b77/d38c6004b9254ec2a89176e0fbec6b77.HD-1080p-7.2Mbps-36776000.mp4?v=0', poster: 'https://freelifelabs.com/cdn/shop/files/preview_images/d38c6004b9254ec2a89176e0fbec6b77.thumbnail.0000000000_540x.jpg?v=1729559143', cap: 'NerveReverse customer', c: 'nerve' },
    { src: 'https://freelifelabs.com/cdn/shop/videos/c/vp/039ac0d28849434fb6167c4cbd2f884f/039ac0d28849434fb6167c4cbd2f884f.HD-720p-1.6Mbps-36775997.mp4?v=0', poster: 'https://freelifelabs.com/cdn/shop/files/preview_images/039ac0d28849434fb6167c4cbd2f884f.thumbnail.0000000000_540x.jpg?v=1729559111', cap: 'NerveReverse customer', c: 'nerve' },
    { src: 'https://freelifelabs.com/cdn/shop/videos/c/vp/aad0db2250da4aa285d6949a317d0368/aad0db2250da4aa285d6949a317d0368.HD-1080p-4.8Mbps-36776001.mp4?v=0', poster: 'https://freelifelabs.com/cdn/shop/files/preview_images/aad0db2250da4aa285d6949a317d0368.thumbnail.0000000000_540x.jpg?v=1729559147', cap: 'NerveReverse customer', c: 'nerve' },
    { src: 'https://freelifelabs.com/cdn/shop/videos/c/vp/a2fe840cbd22419396946ad97be65cff/a2fe840cbd22419396946ad97be65cff.HD-1080p-7.2Mbps-35911143.mp4?v=0', poster: 'https://freelifelabs.com/cdn/shop/files/preview_images/a2fe840cbd22419396946ad97be65cff.thumbnail.0000000000_540x.jpg?v=1728267888', cap: 'NerveReverse customer', c: 'nerve' },
    { src: 'https://freelifelabs.com/cdn/shop/videos/c/vp/5dee42e77c3d44b8929d12010c42ad1e/5dee42e77c3d44b8929d12010c42ad1e.HD-1080p-2.5Mbps-35911144.mp4?v=0', poster: 'https://freelifelabs.com/cdn/shop/files/preview_images/5dee42e77c3d44b8929d12010c42ad1e.thumbnail.0000000000_540x.jpg?v=1728267907', cap: 'NerveReverse customer', c: 'nerve' }
  ];


  var VOICES = [
 {
  "c": "nerve",
  "who": "Jen S",
  "title": "Helps My Arm",
  "quote": "For the last 4 months I have been dealing with tingling and numbness in my right hand and arm. It would There were times I had difficulty finishing simple chores like vacuuming so I had to frequently stop and massage my arm out. It seemed like it was getting worse as each day passed. I was intrigued by this NerveReverse. I wasn't sure…",
  "kind": "customer",
  "stars": 5,
  "full": "For the last 4 months I have been dealing with tingling and numbness in my right hand and arm. It would There were times I had difficulty finishing simple chores like vacuuming so I had to frequently stop and massage my arm out. It seemed like it was getting worse as each day passed. I was intrigued by this NerveReverse. I wasn't sure how well it would work for me because it seemed to target the legs and feet. But I gave it a shot anyway with the belief that this would benefit the entire nervous system and that our bodies have more nerves than just the ones in our feet and legs. I'm very happy to say that after 2 weeks of taking 1 capsule a day the tingling has subsided. I can actually complete my vacuuming without pain. No more frequent breaks. The tingling and numbness used to be on a scale of 6-7 but today it's down to a 3 which is a big relief. I feel it's been very effective so far. I do feel a big difference indeed and will continue taking every day. This is remarkable stuff.",
  "verified": false
 },
 {
  "c": "nerve",
  "who": "Douglas Allan",
  "title": "Amazing",
  "quote": "This cream is amazing. I put it on my feet each night before I go to sleep. My neuropathy is immediately relaxed and I can fall asleep quickly and feel comfortable without restless legs for up to 6-8 hours before having to put more on. I have not found anything else that works as effectively as NerveReverse.",
  "kind": "customer",
  "stars": 5,
  "verified": true
 },
 {
  "c": "skin",
  "who": "Laura Brainard",
  "title": "Smooth feet!",
  "quote": "I love that this Urea Cream for Feet (42% Maximum Strength) comes from a small business! It works really well, softening dry, rough feet and making them feel much smoother. The formula is deeply moisturizing and gently exfoliates while locking in hydration. I also appreciate that it’s fragrance-free and paraben-free, so it’s gentle on my…",
  "kind": "customer",
  "stars": 5,
  "full": "I love that this Urea Cream for Feet (42% Maximum Strength) comes from a small business! It works really well, softening dry, rough feet and making them feel much smoother. The formula is deeply moisturizing and gently exfoliates while locking in hydration.\n\nI also appreciate that it’s fragrance-free and paraben-free, so it’s gentle on my skin. The added mango and shea butters make it feel extra nourishing. Plus, the included pumice stone and brush are a nice bonus! Definitely a great find for keeping feet soft.",
  "verified": false
 },
 {
  "c": "wound",
  "who": "Alysia G.",
  "title": "This really worked well for me",
  "quote": "I'm not even sure how I stumbled across this product in the first place, but the reviews had me sold. I'd been preparing for back surgery for months and this was a last-minute purchase. The doctors ended up going through my stomach, shifting things about and tackled my back issues that way. I started taking this supplement the very first…",
  "kind": "customer",
  "stars": 5,
  "full": "I'm not even sure how I stumbled across this product in the first place, but the reviews had me sold. I'd been preparing for back surgery for months and this was a last-minute purchase. The doctors ended up going through my stomach, shifting things about and tackled my back issues that way.\n\nI started taking this supplement the very first day I got home from the hospital. Yesterday, I had a two-week follow-up; my orthopedic doctor, his PA and the nurse were almost stunned by how well the incision had healed. I can't vouch for the previous reviews claiming that this provided energy and more help than pain meds and antibiotics, but the reaction of the doctors was more than enough to convince me that I'd made the right purchase.",
  "verified": true
 },
 {
  "c": "wound",
  "who": "John M",
  "title": "Great addition to any emergency kit",
  "quote": "My wife wanted to try the WoundWorx dressing gel because she is constantly getting little cuts and scrapes on her hands. She has very sensitive skin and most products that she has tried will cause her skin to break out in a rash. She has used another form of silver cream in the past with great success and she was eager to try this gel.…",
  "kind": "customer",
  "stars": 5,
  "full": "My wife wanted to try the WoundWorx dressing gel because she is constantly getting little cuts and scrapes on her hands.\n\nShe has very sensitive skin and most products that she has tried will cause her skin to break out in a rash. She has used another form of silver cream in the past with great success and she was eager to try this gel.\n\nThe gel has no scent and goes on smoothly without leaving a residue and works well on sensitive skin. It has aided her healing and did not require a large amount of the product to see the results. She is very pleased with this product and will be purchasing more when it is needed.",
  "verified": false
 },
 {
  "c": "nerve",
  "who": "Dr. Daniel Huff, DPM",
  "title": "",
  "quote": "Initially, in our office we used a different nerve supplement, but upon switching to NerveReverse our patients have seen tremendous improvement. We recommend this to all our patients suffering from slightly painful to debilitating nerve conditions.",
  "kind": "clinician",
  "stars": 5
 },
 {
  "c": "nerve",
  "who": "Karen Leonard, DPM",
  "brand": "NerveReverse Pain Cream",
  "title": "",
  "quote": "The patients not only say that it is effective and helps almost immediately, but that it also lasts the longest of any topical that they have tried. It is easy to apply and is not greasy or too thick.",
  "kind": "clinician",
  "stars": 5
 },
 {
  "c": "skin",
  "who": "Dr J.",
  "title": "",
  "quote": "We have been using in our clinic and it works very well for calluses.",
  "kind": "clinician",
  "stars": 5
 },
 {
  "c": "nerve",
  "who": "J. Randal Young, DPM",
  "title": "",
  "quote": "NerveReverse has been a “life saver” for many of my patients. It really sells itself. I have noticed less pain, and paresthesias. My experience is that it is as good or better than Metanx for diabetic peripheral neuropathy.",
  "kind": "clinician",
  "stars": 5
 }
];


  /* ---------- helpers ---------- */
  function money(cents) {
    var v = (Number(cents) || 0) / 100;
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' }).format(v); }
    catch (e) { return '$' + v.toFixed(2); }
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
  function whenNear(el, fn) {
    var done = false; function go() { if (done) return; done = true; fn(); }
    if (!el || !('IntersectionObserver' in window)) return go();
    var o = new IntersectionObserver(function (es) { for (var i = 0; i < es.length; i++) if (es[i].isIntersecting) { o.disconnect(); go(); return; } }, { rootMargin: '700px 0px' });
    o.observe(el);
  }
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- product cards: size + Subscribe & Save -> price ---------- */
  function state(box) {
    var size = box.querySelector('[data-zn-size]:checked');
    var src = size || box;
    var sub = box.querySelector('[data-zn-buy="sub"]');
    return {
      variant: size ? size.value : box.getAttribute('data-variant'),
      price: Number(src.getAttribute('data-price') || 0),
      subPrice: Number(src.getAttribute('data-sub') || 0),
      plan: src.getAttribute('data-plan') || '',
      days: Number(src.getAttribute('data-days') || 0),
      wantsSub: !!(sub && sub.checked)
    };
  }
  function paint(box) {
    var s = state(box);
    var subIn = box.querySelector('[data-zn-buy="sub"]');
    if (subIn) {
      var row = subIn.closest('label');
      if (row) row.style.visibility = s.plan ? '' : 'hidden';
      if (!s.plan && subIn.checked) subIn.checked = false;
    }
    var subOn = s.wantsSub && /^\d+$/.test(s.plan);
    var pr = box.querySelector('[data-zn-price]');
    if (pr) pr.textContent = money(subOn ? s.subPrice : s.price);
    var sp = box.querySelector('[data-zn-subprice]');
    if (sp) sp.textContent = money(s.subPrice);
    var pd = box.querySelector('[data-zn-perday]');
    if (pd) { pd.textContent = s.days ? 'about ' + money(Math.round(s.price / s.days)) + '/day' : ''; pd.hidden = !s.days; }
  }
  [].forEach.call(document.querySelectorAll('[data-zn-prod]'), paint);
  document.addEventListener('change', function (e) {
    var box = e.target.closest && e.target.closest('[data-zn-prod]');
    if (box && (e.target.matches('[data-zn-size]') || e.target.matches('[data-zn-buy]'))) paint(box);
  });
  window.addEventListener('pageshow', function () { [].forEach.call(document.querySelectorAll('[data-zn-prod]'), paint); });

  /* ---------- add to cart: /cart/add.js, selling_plan only when Subscribe & Save is ticked ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-zn-add]');
    if (!b || b.disabled) return;
    e.preventDefault();
    var box = b.closest('[data-zn-prod]');
    if (!box) return;
    var s = state(box);
    var line = { id: Number(s.variant), quantity: 1 };
    if (s.wantsSub && /^\d+$/.test(s.plan) && !document.querySelector('[data-zn-wholesale]')) line.selling_plan = Number(s.plan);
    var label = b.textContent;
    b.disabled = true; b.textContent = 'Adding\u2026';
    var err = box.querySelector('[data-zn-err]'); if (err) err.textContent = '';
    addToCart([line], function () {
      b.disabled = false;
      b.textContent = line.selling_plan ? 'Subscribed \u2713' : 'Added \u2713';
      setTimeout(function () { b.textContent = label; }, 2400);
    }, function (msg) {
      b.disabled = false; b.textContent = label;
      if (!err) { err = document.createElement('p'); err.setAttribute('data-zn-err', ''); err.setAttribute('role', 'alert'); err.className = 'zn-err'; b.parentNode.insertBefore(err, b.nextSibling); }
      err.textContent = msg;
    });
  }, true);

  /* ---------- cart drawer: overlay click + Escape that survive section re-renders ----------
     The theme binds the overlay click once, on the overlay element. Any innerHTML refresh of the drawer
     (our add-to-cart, quantity changes) swaps that element out, so bind at document level instead. */
  (function () {
    function drawerOpen() { var d = document.querySelector('cart-drawer'); return d && d.classList.contains('active') ? d : null; }
    document.addEventListener('click', function (e) {
      var d = drawerOpen();
      if (d && e.target && e.target.id === 'CartDrawer-Overlay' && typeof d.close === 'function') d.close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' && e.key !== 'Esc') return;
      var d = drawerOpen();
      if (d && typeof d.close === 'function') d.close();
    });
  })();

  /* ---------- rails ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-zn-rail]');
    if (!a) return;
    var rail = document.getElementById(a.getAttribute('data-zn-target'));
    if (!rail) return;
    var card = rail.firstElementChild;
    var step = card ? card.getBoundingClientRect().width + 16 : rail.clientWidth * 0.8;
    rail.scrollBy({ left: step * Number(a.getAttribute('data-zn-rail')), behavior: reduce ? 'auto' : 'smooth' });
  });
  var BRAND = { nerve: 'NerveReverse', skin: 'Derm 42', wound: 'WoundWorx' };
  var vrail = document.getElementById('zn-vrail'), wrail = document.getElementById('zn-wrail');
  var WQ = [];
  function paras(t) { return String(t || '').trim().split(/\n\s*\n/).map(function (p) { return '<p>' + esc(p.trim()).replace(/\n/g, '<br>') + '</p>'; }).join(''); }
  var extra = [];
  try { extra = JSON.parse((document.getElementById('zn-videos') || {}).textContent || '[]'); } catch (e2) { extra = []; }
  var seen = {};
  var VIDS = VIDEOS.concat(extra).filter(function (v) { if (!v || !v.src || seen[v.src]) return false; seen[v.src] = 1; return true; });
  if (vrail) whenNear(vrail, function () {
    vrail.innerHTML = VIDS.map(function (v) {
      return '<figure class="zn-v" style="--c:var(--' + esc(v.c) + ')"><video src="' + esc(v.src) + '"' + (v.poster ? ' poster="' + esc(v.poster) + '"' : '') + ' controls preload="none" playsinline aria-label="' + esc(v.cap) + ' video"></video><figcaption><b>' + esc(v.cap) + '</b></figcaption></figure>';
    }).join('');
  });
  function initials(n) { return String(n || '').replace(/^Dr\.?\s+/i, '').split(/[\s,]+/).filter(function (w) { return /^[A-Za-z]/.test(w) && !/^(DPM|MD)$/.test(w); }).slice(0, 2).map(function (w) { return w.charAt(0).toUpperCase(); }).join(''); }
  if (wrail) whenNear(wrail, function () {
    /* one card per person/quote: skip voices already shown in the podiatrist rail or earlier in this list */
    function qk(t) { return String(t || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim().slice(0, 80); }
    function nk(t) { return String(t || '').toLowerCase().replace(/<[^>]*>/g, '').replace(/·.*$/, '').replace(/\b(dr|dpm|md|podiatry)\b/g, '').replace(/[^a-z]+/g, ''); }
    var seenQ = {}, seenN = {};
    function mark(who, q) { var n = nk(who); if (n.length > 3) seenN[n] = 1; var k = qk(q); if (k) seenQ[k] = 1; }
    Array.prototype.forEach.call(document.querySelectorAll('.zn-pro-card, #zn-wrail .zn-q'), function (c) {
      var b = c.querySelector('b'), q = c.querySelector('blockquote'); mark(b && b.textContent, q && q.textContent);
    });
    var list = VOICES.filter(function (v) {
      var n = nk(v.who), k = qk(v.quote);
      if ((k && seenQ[k]) || (n.length > 3 && seenN[n])) return false;
      mark(v.who, v.quote); return true;
    });
    WQ = list;
    wrail.insertAdjacentHTML('beforeend', list.map(function (v) {
      var doc = v.kind === 'clinician';
      var tag = doc ? (/DPM/.test(v.who) ? 'Podiatrist' : 'Clinician') : (v.verified ? 'Verified buyer' : '');
      var n = Math.max(1, Math.min(5, Number(v.stars) || 5));
      return '<figure class="zn-q" style="--c:var(--' + esc(v.c) + ')"><span class="zn-stars" aria-label="' + n + ' out of 5 stars">' + new Array(n + 1).join('\u2605') + '</span>' +
        '<span class="zn-q-pill">' + esc(v.brand || BRAND[v.c] || '') + '</span>' +
        (v.title ? '<p class="zn-q-title"><button type="button" class="zn-q-open" data-zn-rv="q:' + WQ.indexOf(v) + '" aria-haspopup="dialog">' + esc(v.title) + '</button></p>' : '') +
        '<blockquote>' + esc(String(v.full || v.quote || '').replace(/\s+/g, ' ').trim()) + '</blockquote>' +
        '<button type="button" class="zn-q-more" data-zn-rv="q:' + WQ.indexOf(v) + '" aria-haspopup="dialog" hidden>Read more<span class="zn-sr"> of the review by ' + esc(v.who) + '</span></button>' +
        '<figcaption><span class="zn-q-av" aria-hidden="true">' + esc(initials(v.who)) + '</span><span><b>' + esc(v.who) + '</b>' + (tag ? '<span class="zn-q-tag">' + tag + '</span>' : '') + '</span></figcaption></figure>';
    }).join(''));
    /* Read more only where the clamped text really overflows its tile (re-measured on every width change) */
    function measureQ() {
      Array.prototype.forEach.call(wrail.querySelectorAll('.zn-q'), function (t) {
        var q = t.querySelector('blockquote'), b = t.querySelector('.zn-q-more');
        if (q && b) b.hidden = !(q.scrollHeight - q.clientHeight > 2);
      });
    }
    measureQ();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measureQ);
    var qw = 0, qraf = 0;
    if (window.ResizeObserver) new ResizeObserver(function () {
      var w = wrail.clientWidth; if (w === qw) return; qw = w;
      cancelAnimationFrame(qraf); qraf = requestAnimationFrame(measureQ);
    }).observe(wrail);
    else window.addEventListener('resize', function () { cancelAnimationFrame(qraf); qraf = requestAnimationFrame(measureQ); });
  });


  /* ---------- reviews pop-up: every review mention opens it; product data loads on first open ---------- */
  (function () {
    var root = document.getElementById('zn-rv');
    if (!root) return;
    /* move to <body> so position:fixed is relative to the viewport (theme wrappers can create a containing block) */
    if (root.parentNode !== document.body) document.body.appendChild(root);
    var panel = root.querySelector('.zn-rv-panel'), body = document.getElementById('zn-rv-body');
    var hEl = document.getElementById('zn-rv-h'), subEl = document.getElementById('zn-rv-sub'), kEl = document.getElementById('zn-rv-k');
    var SEC = { nc: 'custom-homepage-zen-rv-nc', pc: 'custom-homepage-zen-rv-pc', dm: 'custom-homepage-zen-rv-dm', ww: 'custom-homepage-zen-rv-ww', wg: 'custom-homepage-zen-rv-wg' };
    var cache = {}, lastTrigger = null, savedY = 0, isOpen = false, inerted = [];
    function prodInfo(key) {
      var b = document.querySelector('.zn-bc-rate[data-zn-rv="' + key + '"]');
      return b ? { key: key, title: b.getAttribute('data-title'), avg: b.getAttribute('data-avg'), n: b.getAttribute('data-n'), loox: b.getAttribute('data-loox') } : null;
    }
    function sectionUrl(id) {
      var q = new URLSearchParams(location.search); q.set('sections', id);
      return location.pathname + '?' + q.toString();
    }
    function loadListing(key) {
      if (cache[key]) return cache[key];
      cache[key] = fetch(sectionUrl(SEC[key]), { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (j) { var h = j[SEC[key]] || ''; var t = document.createElement('div'); t.innerHTML = h; var list = t.querySelector('.fll-amz-list'); if (!list) throw new Error('empty'); return list.outerHTML; })
        .catch(function (e) { delete cache[key]; throw e; });
      return cache[key];
    }
    function renderAll() {
      kEl.textContent = 'Customers & clinicians';
      hEl.textContent = root.getAttribute('data-avg') + ' / 5 from ' + root.getAttribute('data-n') + ' reviews';
      subEl.textContent = 'Written reviews shown as written. Individual results vary. Reviews are not a guarantee of specific outcomes.';
      var chips = ['nc', 'pc', 'dm', 'ww', 'wg'].map(prodInfo).filter(Boolean).map(function (p) {
        return '<button type="button" class="zn-rv-chip" data-zn-rv-prod="' + p.key + '">' + esc(p.title) + ' · ' + esc(p.avg) + '★ (' + esc(p.n) + ')</button>';
      }).join('');
      var seen = {};
      var cards = VOICES.filter(function (v) { var k = String(v.quote || '').replace(/\s+/g, ' ').trim().toLowerCase(); if (!k || seen[k]) return false; seen[k] = 1; return true; }).map(function (v) {
        var n = Math.max(1, Math.min(5, Number(v.stars) || 5));
        var tag = v.kind === 'clinician' ? (/DPM/.test(v.who) ? 'Podiatrist' : 'Clinician') : (v.verified ? 'Verified buyer' : '');
        return '<article class="zn-rv-card" style="--c:var(--' + esc(v.c) + ')"><span class="zn-stars" aria-label="' + n + ' out of 5 stars">' + new Array(n + 1).join('\u2605') + '</span><span class="zn-rv-pill">' + esc(v.brand || BRAND[v.c] || '') + '</span>' +
          (v.title ? '<p class="zn-rv-title"><b>' + esc(v.title) + '</b></p>' : '') +
          '<blockquote>' + (v.full ? paras(v.full) : esc(String(v.quote || '').replace(/\s+/g, ' ').trim())) + '</blockquote><footer><b>' + esc(v.who) + '</b>' + (tag ? ' · ' + tag : '') + '</footer></article>';
      }).join('');
      body.innerHTML = '<p class="zn-rv-kick">Reviews by product</p><div class="zn-rv-chips">' + chips + '</div><p class="zn-rv-kick">Customer reviews</p><div class="zn-rv-list">' + cards + '</div>';
    }
    function renderOne(i) {
      var v = WQ[i]; if (!v) return renderAll();
      var n = Math.max(1, Math.min(5, Number(v.stars) || 5));
      var tag = v.kind === 'clinician' ? (/DPM/.test(v.who) ? 'Podiatrist' : 'Clinician') : (v.verified ? 'Verified buyer' : '');
      kEl.textContent = v.brand || BRAND[v.c] || 'Customer review';
      hEl.textContent = v.title || 'Customer review';
      subEl.textContent = v.who + (tag ? ' · ' + tag : '') + '. Shown as written. Individual results vary.';
      body.innerHTML = '<article class="zn-rv-card zn-rv-one" style="--c:var(--' + esc(v.c) + ')"><span class="zn-stars" aria-label="' + n + ' out of 5 stars">' + new Array(n + 1).join('\u2605') + '</span>' +
        '<blockquote>' + paras(v.full || v.quote) + '</blockquote></article>' +
        '<button type="button" class="zn-rv-back" data-zn-rv-all>Read all reviews ›</button>';
      body.scrollTop = 0;
    }
    function renderProd(key, fromAll) {
      var p = prodInfo(key); if (!p) return renderAll();
      kEl.textContent = p.title;
      hEl.textContent = p.avg + ' / 5 from ' + p.n + ' reviews';
      subEl.textContent = 'Customer reviews, the same ones shown on the product page. Individual results vary. Reviews are not a guarantee of specific outcomes.';
      body.innerHTML = (fromAll ? '<button type="button" class="zn-rv-back" data-zn-rv-all>‹ All reviews</button>' : '') +
        '<p class="zn-rv-kick">Customer reviews</p><div data-zn-rv-listing><p class="zn-rv-wait" role="status">Loading reviews…</p></div>' +
        '<p class="zn-rv-kick">Site reviews</p><div data-zn-rv-site></div>';
      body.scrollTop = 0;
      var slot = body.querySelector('[data-zn-rv-listing]');
      loadListing(key).then(function (h) { if (isOpen && slot.isConnected) slot.innerHTML = h; })
        .catch(function () { if (slot.isConnected) slot.innerHTML = '<p class="zn-rv-wait">Reviews could not load. Please try again.</p>'; });
      var hash = window.loox_global_hash || '';
      if (p.loox) {
        var f = document.createElement('iframe');
        f.className = 'zn-rv-loox'; f.title = p.title + ' site reviews'; f.loading = 'lazy'; f.tabIndex = -1; /* keep keyboard focus (Tab / Escape) in the pop-up; the frame still scrolls by touch and mouse */
        f.src = 'https://loox.io/widget/o--LjEPB2x/reviews/' + encodeURIComponent(p.loox) + '?h=' + encodeURIComponent(hash) + '&page=1';
        body.querySelector('[data-zn-rv-site]').appendChild(f);
      }
    }
    function focusables() { return [].slice.call(panel.querySelectorAll('button, [href], iframe, input, [tabindex]:not([tabindex="-1"])')).filter(function (el) { return !el.disabled && el.tabIndex >= 0 && el.offsetParent !== null; }); }
    function open(key, trigger) {
      lastTrigger = trigger || document.activeElement;
      if (!isOpen) {
        savedY = window.scrollY || window.pageYOffset || 0;
        document.documentElement.classList.add('zn-rv-lock');
        root.hidden = false; isOpen = true;
        inerted = [].slice.call(document.body.children).filter(function (el) { return el !== root && !el.inert && el.tagName !== 'SCRIPT'; });
        inerted.forEach(function (el) { el.inert = true; });
      }
      if (key === 'all') renderAll(); else if (/^q:/.test(key)) renderOne(Number(key.slice(2))); else renderProd(key, false);
      var x = root.querySelector('.zn-rv-x'); if (x) x.focus({ preventScroll: true });
    }
    function close() {
      if (!isOpen) return;
      isOpen = false; root.hidden = true; body.innerHTML = '';
      inerted.forEach(function (el) { el.inert = false; }); inerted = [];
      document.documentElement.classList.remove('zn-rv-lock');
      window.scrollTo(0, savedY);
      if (lastTrigger && lastTrigger.focus) lastTrigger.focus({ preventScroll: true });
    }
    window.__znReviews = { open: open, close: close };
    document.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[data-zn-rv]');
      if (t && !root.contains(t)) { e.preventDefault(); open(t.getAttribute('data-zn-rv'), t); return; }
      if (!isOpen) return;
      if (e.target === root || e.target.closest('[data-zn-rv-close]')) { e.preventDefault(); close(); return; }
      var pc = e.target.closest('[data-zn-rv-prod]');
      if (pc) { renderProd(pc.getAttribute('data-zn-rv-prod'), true); var b = body.querySelector('.zn-rv-back'); if (b) b.focus({ preventScroll: true }); return; }
      if (e.target.closest('[data-zn-rv-all]')) { renderAll(); body.scrollTop = 0; var c = body.querySelector('.zn-rv-chip'); if (c) c.focus({ preventScroll: true }); }
    });
    document.addEventListener('keydown', function (e) {
      if (!isOpen) return;
      if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); e.stopPropagation(); close(); return; }
      if (e.key === 'Tab') {
        var f = focusables(); if (!f.length) { e.preventDefault(); panel.focus(); return; }
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && (document.activeElement === first || !panel.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && (document.activeElement === last || !panel.contains(document.activeElement))) { e.preventDefault(); first.focus(); }
      }
    }, true);
  })();


  /* ---------- reveal on scroll: below-the-fold headings and cards fade up once (transform + opacity only) ---------- */
  /* podiatrist cards: clamp long quotes, add a Read more toggle */
  (function () {
    Array.prototype.forEach.call(document.querySelectorAll('.zn-pro-card'), function (c) {
      var q = c.querySelector('blockquote');
      if (!q || q.textContent.length < 300) return;
      c.classList.add('is-clamp');
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'zn-pro-more'; b.setAttribute('aria-expanded', 'false'); b.textContent = 'Read more';
      b.addEventListener('click', function () {
        var open = c.classList.toggle('is-open');
        b.setAttribute('aria-expanded', open ? 'true' : 'false'); b.textContent = open ? 'Show less' : 'Read more';
      });
      q.insertAdjacentElement('afterend', b);
    });
  })();

  (function () {
    var zn = document.querySelector('[data-zn]');
    if (!zn || !('IntersectionObserver' in window) || reduce) return;
    var GROUPS = [
      ['.zn-concern .zn-wrap', ':scope > .zn-kicker, :scope > .zn-h2, :scope > .zn-lede'],
      ['.zn-cgrid', ':scope > li'],
      ['.zn-best .zn-wrap', ':scope > .zn-kicker, :scope > .zn-h2, :scope > .zn-lede'],
      ['.zn-bgrid', ':scope > li'],
      ['.zn-best .zn-wrap', ':scope > .zn-best-fine, :scope > .zn-center'],
      ['.zn-why-top', ':scope > *'],
      ['.zn-qual-head', ':scope > *'], ['.zn-qual-list', ':scope > li'], ['.zn-qual-foot', null],
      ['.zn-pro-head', null], ['.zn-pro-grid', null],
      ['.zn-vids .zn-rowhead', null], ['.zn-vrail', null],
      ['.zn-rev-head', ':scope > *'], ['.zn-wrap-rail', null],
      ['.zn-faq-list', ':scope > *'], ['.zn-faq-side', null]
    ];
    var vh = window.innerHeight, sets = [];
    GROUPS.forEach(function (g) {
      var boxes = zn.querySelectorAll(g[0]);
      Array.prototype.forEach.call(boxes, function (box) {
        if (box.getBoundingClientRect().top < vh) return;          /* already on screen at load: never hide it */
        var items = g[1] ? [].slice.call(box.querySelectorAll(g[1])) : [box];
        items = items.filter(function (el) { return !el.classList.contains('zn-rise'); });
        if (!items.length) return;
        items.forEach(function (el, i) { el.classList.add('zn-rise'); el.style.setProperty('--zn-d', Math.min(i, 5) * 70 + 'ms'); });
        sets.push({ box: box, items: items });
      });
    });
    if (!sets.length) return;
    zn.classList.add('zn-anim');
    function reveal(s) {
      s.items.forEach(function (el) { el.classList.add('is-in'); });
      setTimeout(function () { s.items.forEach(function (el) { el.classList.remove('zn-rise', 'is-in'); el.style.removeProperty('--zn-d'); }); }, 1100);
    }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        sets.forEach(function (s) { if (s.box === e.target && !s.done) { s.done = true; reveal(s); } });
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.01 });
    var seen = [];
    sets.forEach(function (s) { if (seen.indexOf(s.box) < 0) { seen.push(s.box); io.observe(s.box); } });
    /* anything still hidden after a jump (anchor, find-in-page, print) is shown at once */
    window.addEventListener('beforeprint', function () { sets.forEach(function (s) { if (!s.done) { s.done = true; reveal(s); } }); });
  })();

  /* ---------- hero video tile: after load / idle; poster only for reduced motion or Save-Data ---------- */
  (function () {
    var v = document.querySelector('[data-zn-hero-video]');
    if (!v) return;
    var sd = navigator.connection && navigator.connection.saveData;
    if (reduce || sd) { v.parentNode.removeChild(v); return; }
    var started = false;
    function start() {
      if (started) return; started = true;
      var mob = window.matchMedia('(max-width: 749px)').matches;
      v.muted = true;
      v.addEventListener('playing', function () { v.classList.add('is-playing'); }, { once: true });
      v.src = mob ? v.getAttribute('data-src-m') : v.getAttribute('data-src-d');
      var p = v.play(); if (p && p.catch) p.catch(function () {});
    }
    function later() { if ('requestIdleCallback' in window) window.requestIdleCallback(start, { timeout: 1500 }); else setTimeout(start, 200); }
    if (document.readyState === 'complete') later(); else { window.addEventListener('load', later, { once: true }); setTimeout(later, 8000); }
  })();

  /* ---------- in-page links: smooth scroll ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.zn a[href^="#zn-"]');
    if (!a) return;
    var t = document.getElementById(a.getAttribute('href').slice(1));
    if (!t) return;
    e.preventDefault();
    t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  });

  /* ================= PLUS: review tiles open the pop-up (whole tile + title button) ================= */
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('#zn-wrail .zn-q');
    if (!t || e.target.closest('button, a')) return;
    var m = t.querySelector('[data-zn-rv^="q:"]');
    if (m && window.__znReviews) { e.preventDefault(); window.__znReviews.open(m.getAttribute('data-zn-rv'), m); }
  });

})();

/* ---------- premium: cart drawer (short variant label + reassurance line) ---------- */
(function () {
  var root = document.querySelector('[data-zn]');
  var d = document.querySelector('cart-drawer');
  if (!root || !d) return;
  var wholesale = root.hasAttribute('data-zn-wholesale');
  function shortLabel(v) {
    var t = String(v || '').replace(/\s+/g, ' ').replace(/[,\s]+$/, '').trim();
    var parts = t.split('/').map(function (p) {
      return p.replace(/\s+-\s+.*$/, '').replace(/\s+of\s+Supply/i, '').trim()
        .replace(/\b(Days?|Capsules?|Tablets?|Softgels?|Bottles?|Jars?|Tubes?|Months?)\b/g, function (w) { return w.toLowerCase(); });
    }).filter(Boolean);
    return parts.join(' · ');
  }
  function apply() {
    [].forEach.call(d.querySelectorAll('.cart-item .product-option'), function (row) {
      if (row.classList.contains('fll-cd-short')) return;
      var dt = row.querySelector('dt'), dd = row.querySelector('dd');
      if (!dt || !dd || dd.querySelector('a')) return;
      var name = dt.textContent.trim();
      if (/^(Title|Size|Days of Supply|.*Supply.*|.*Capsules.*)/i.test(name)) {
        var s = shortLabel(dd.textContent);
        if (s) { dd.textContent = s; row.classList.add('fll-cd-short'); }
      }
    });
    var ctas = d.querySelector('.cart__ctas');
    if (ctas && !d.querySelector('.fll-cd-assure')) {
      var el = document.createElement('p');
      el.className = 'fll-cd-assure';
      el.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3l7 3v5c0 4.5-3 8.3-7 10-4-1.7-7-5.5-7-10V6z" fill="none" stroke="currentColor" stroke-width="1.8"/></svg>' +
        (wholesale ? 'Money-back guarantee' : 'Free shipping · Money-back guarantee');
      ctas.parentNode.insertBefore(el, ctas);
    }
  }
  apply();
  var busy = false;
  new MutationObserver(function () { if (busy) return; busy = true; requestAnimationFrame(function () { apply(); busy = false; }); })
    .observe(d, { childList: true, subtree: true });
})();
